import prescriptionList from './prescription_list.json'

export type PrescriptionCatalogRow = {
  id: string
  en: string
  fr: string
  ordo_type?: string
  aliases?: string[]
}

export const PRESCRIPTION_CATALOG: PrescriptionCatalogRow[] = prescriptionList

const BY_ID = new Map(PRESCRIPTION_CATALOG.map((row) => [row.id, row]))

export function prescriptionFriendlyLabel(id: string | null | undefined, fr: boolean): string {
  const key = (id || '').trim()
  if (!key) return '—'
  const row = BY_ID.get(key)
  if (!row) return key
  return fr ? row.fr : row.en
}
